<div #banner ngbAutofocus class="bannerContainer">
  <button class="close_icon" (click)="closeModal()"></button>
  <a href="{{bannerUrl?.urlLink}}" class="redirectionUrl"
    *ngIf="bannerUrl?.header && bannerUrl?.urlLink" (click)="gtmSelectPromotion()">{{bannerUrl?.header}}</a>
</div>